export default {
    texts:[]
}